export const one = `"Merriweather", sans`;
export const two = `'Libre Baskerville', serif`;
export const three = `'Roboto', sans-serif`;
export const four = `monospace`;
